import React from "react";
import "./i18n/config";

import {
  AboutUs,
  Banner,
  FindUs,
  Footer,
  Gallery,
  Header,
  Intro,
  SocialMedia,
  SpecialMenu,
} from "./container/ClientPage";
import { Navbar, BookingForm } from "./components/ClientPage";
import "./App.css";

const ClientPage = () => (
  <div>
    <Navbar />
    <Header />
    <Banner />
    <AboutUs />
    <SpecialMenu />
    <Intro />
    <Gallery />
    <BookingForm />
    <FindUs />
    <Footer />
    <SocialMedia />
  </div>
);

export default ClientPage;
